import { cn } from "@thilke/ui/lib/utils";
import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";

const markdownSurfaceVariants = cva(
  [
    "text-sm leading-6 text-foreground",
    "[overflow-wrap:anywhere]",
    "[&_a]:text-primary [&_a]:underline [&_a]:underline-offset-4",
    "[&_a:hover]:text-primary/85",
    "[&_blockquote]:my-3 [&_blockquote]:border-l-2 [&_blockquote]:border-line-strong [&_blockquote]:pl-3 [&_blockquote]:text-muted-foreground",
    "[&_code]:rounded [&_code]:bg-surface-sunken [&_code]:px-1 [&_code]:py-0.5 [&_code]:font-mono [&_code]:text-[0.85em]",
    "[&_h1]:mb-2 [&_h1]:mt-4 [&_h1]:text-xl [&_h1]:font-semibold [&_h1]:leading-7",
    "[&_h2]:mb-2 [&_h2]:mt-4 [&_h2]:text-lg [&_h2]:font-semibold [&_h2]:leading-6",
    "[&_h3]:mb-1.5 [&_h3]:mt-3 [&_h3]:text-base [&_h3]:font-semibold [&_h3]:leading-6",
    "[&_hr]:my-4 [&_hr]:border-line-subtle",
    "[&_li]:my-1",
    "[&_ol]:my-3 [&_ol]:list-decimal [&_ol]:pl-5",
    "[&_p]:my-2",
    "[&_pre]:my-3 [&_pre]:overflow-x-auto [&_pre]:rounded-[5px] [&_pre]:border [&_pre]:border-line-subtle [&_pre]:bg-surface-sunken [&_pre]:p-3",
    "[&_pre_code]:bg-transparent [&_pre_code]:p-0",
    "[&_table]:my-3 [&_table]:border-collapse",
    "[&_td]:border [&_td]:border-line-subtle [&_td]:px-2 [&_td]:py-1 [&_td]:align-top",
    "[&_th]:border [&_th]:border-line-subtle [&_th]:bg-surface-raised [&_th]:px-2 [&_th]:py-1 [&_th]:text-left [&_th]:font-medium",
    "[&_ul]:my-3 [&_ul]:list-disc [&_ul]:pl-5",
  ].join(" "),
  {
    variants: {
      density: {
        compact: "text-sm leading-6",
        document: "text-sm leading-7",
      },
    },
    defaultVariants: {
      density: "compact",
    },
  },
);

function MarkdownSurface({
  className,
  density,
  ...props
}: React.ComponentProps<"div"> & VariantProps<typeof markdownSurfaceVariants>) {
  return (
    <div
      data-slot="markdown-surface"
      className={cn(markdownSurfaceVariants({ density, className }))}
      {...props}
    />
  );
}

export { MarkdownSurface, markdownSurfaceVariants };
